
<template>
  <!-- <vs-popup class="holamundo view-merchant" popup-class="w-9/12" :title='"  \""+shopName+"\""' :active.sync="popupActive"> -->
  <div>
    <div class="statuses-nav mx-8">
      <template v-for="(x, i) in steps">
        <feather-icon
          class="time-line-item mx-4"
          :key="i"
          v-if="i > 0"
          strokeWidth="2"
          title="پیشفرض"
          icon="ChevronLeftIcon"
          svgClasses="h-6 w-6"
        ></feather-icon>
        <!-- {{x[0]}} -->
        <div
          class="time-line-item"
          :class="{ active: x.active }"
          :key="'step' + i"
        >
          <div class="icon">
            <feather-icon
              strokeWidth="2"
              :icon="x.icon"
              svgClasses="h-6 w-6"
            ></feather-icon>
          </div>
          <div class="title">{{ x.title }}</div>
        </div>
      </template>
    </div>
    <hr style="width: 100%" />
    <div class="statuses-nav mx-8">
      <template v-for="(x, i) in states">
        <feather-icon
          class="time-line-item mx-4"
          :key="i"
          v-if="i > 0"
          strokeWidth="2"
          icon="ChevronLeftIcon"
          svgClasses="h-6 w-6"
        ></feather-icon>
        <!-- {{x[0]}} -->
        <div
          class="time-line-item"
          :class="{ active: x.active }"
          :key="'state' + i"
        >
          <div class="icon">
            <feather-icon
              strokeWidth="2"
              title="پیشفرض"
              :icon="x.icon"
              svgClasses="h-6 w-6"
            ></feather-icon>
          </div>
          <div class="title">{{ x.title }}</div>
        </div>
      </template>
    </div>
  </div>
  <!-- </vs-popup> -->
</template>
<style lang="scss" scoped >
.statuses-nav {
  flex-wrap: nowrap;
  display: flex;
  justify-content: center;
  flex-direction: row;
  font-size: 0.75rem;
}
.time-line-item {
  color: rgb(255, 255, 255);
  display: inline-flex;
  align-items: center;
  .icon {
    display: none; // inline-flex;
    margin: 0 12px;
    border: 3px solid #ccc;
    border-radius: 100%;
    padding: 6px;
  }
  svg {
    color: #ccc !important;
  }
  .title {
    text-align: center;
    opacity: 0.5;
  }
}

.time-line-item.active,
.time-line-item.active {
  color: rgb(255, 255, 255);
  border: 0 solid rgb(255, 103, 32);
  border-width: 0 0 3px;
  .icon {
    border-color: peru;
  }
  svg {
    color: peru !important;
  }
  .title {
    opacity: 1;
  }
}
</style>
<script>
import { DraftStep, DraftState } from "@/enums.js";
export default {
  name: "draft-merchant-current-status",
  data() {
    return {
      DraftStep,
      DraftState,
    };
  },
  props: {
    stepNo: {
      type: Number,
    },
    stateNo: {
      type: Number,
    },
  },
  computed: {
    steps() {
      //new Merchant
      if ([1, 13, 5].includes(this.stepNo)) {
        let items = Object.values(this.DraftStep).filter((x) =>
          [1, 13].includes(x.value)
        );
        items.push(Object.values(this.DraftStep).find((x) => x.value == 5));
        let index = [1, 13, 5].findIndex((x) => x == this.stepNo);
        items.forEach((x, i) => {
          x.active = i <= index;
        });

        return items;
      }
      // other actions
      else {
        return Object.values(this.DraftStep).find(
          (x) => x.value == this.stepNo
        );
      }
    },
    states() {
      let items = Object.values(this.DraftState).filter((x) =>
        [0, 1, 2, 3, 8].includes(x.value)
      );

      if ([0, 1, 2, 3, 8, 14].includes(this.stateNo)) {
        items.push(Object.values(this.DraftState).find((x) => x.value == 14));
      }
      // other actions
      else {
        items.push(
          Object.values(this.DraftState).find((x) => x.value == this.stateNo)
        );
      }
      let index = items.findIndex((x) => x.value == this.stateNo);
      items.forEach((x, i) => {
        x.active = i <= index;
      });
      return items;
    },
  },
  methods: {},
  mounted() {},
};
</script>